<script>
  import { router } from '@inertiajs/svelte'
  
  let { errors = {}, alert = null } = $props();
  
  let passwordChallenge = $state('');
  let password = $state('');
  let passwordConfirmation = $state('');
  
  function submit(event) {
    event.preventDefault();
    router.patch('/password', {
      password_challenge: passwordChallenge,
      password,
      password_confirmation: passwordConfirmation
    });
  }
  
  // Helper for error display
  function hasError(field) {
    return errors[field] !== undefined;
  }
  
  function getErrorMessages() {
    const messages = [];
    for (const field in errors) {
      if (Array.isArray(errors[field])) {
        errors[field].forEach(message => {
          messages.push(`${field} ${message}`);
        });
      }
    }
    return messages;
  }
  
  // Count total errors
  function countErrors() {
    let count = 0;
    for (const field in errors) {
      if (Array.isArray(errors[field])) {
        count += errors[field].length;
      }
    }
    return count;
  }
</script>

<div class="password-container">
  {#if alert}
    <p class="alert">{alert}</p>
  {/if}

  <h1>Change your password</h1>
  
  {#if Object.keys(errors).length > 0}
    <div class="error-summary">
      <h2>{countErrors()} {countErrors() === 1 ? 'error' : 'errors'} prohibited this user from being saved:</h2>
      
      <ul>
        {#each getErrorMessages() as message}
          <li>{message}</li>
        {/each}
      </ul>
    </div>
  {/if}
  
  <form onsubmit={submit}>
    <div class="form-group">
      <label for="password_challenge" class="form-label">Password challenge</label>
      <!-- svelte-ignore a11y_autofocus -->
      <input 
        id="password_challenge" 
        type="password" 
        bind:value={passwordChallenge} 
        required 
        autofocus 
        autocomplete="current-password"
        class={hasError('password_challenge') ? 'form-input error' : 'form-input'}
      />
      {#if hasError('password_challenge')}
        <div class="error-message">{errors.password_challenge.join(', ')}</div>
      {/if}
    </div>
    
    <div class="form-group">
      <label for="password" class="form-label">New password</label>
      <input 
        id="password" 
        type="password" 
        bind:value={password} 
        required 
        autocomplete="new-password"
        class={hasError('password') ? 'form-input error' : 'form-input'}
      />
      <div class="form-hint">12 characters minimum.</div>
      {#if hasError('password')}
        <div class="error-message">{errors.password.join(', ')}</div>
      {/if}
    </div>
    
    <div class="form-group">
      <label for="password_confirmation" class="form-label">Confirm new password</label>
      <input 
        id="password_confirmation" 
        type="password" 
        bind:value={passwordConfirmation} 
        required 
        autocomplete="new-password"
        class={hasError('password_confirmation') ? 'form-input error' : 'form-input'}
      />
      {#if hasError('password_confirmation')}
        <div class="error-message">{errors.password_confirmation.join(', ')}</div>
      {/if}
    </div>
    
    <div class="form-actions">
      <button type="submit" class="save-button">Save changes</button>
    </div>
  </form>
  
  <div class="back-link">
    <a href="/">Back</a>
  </div>
</div>

<style>
  .password-container {
    max-width: 500px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  
  h1 {
    font-size: 1.875rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }
  
  .alert {
    color: #b91c1c;
    margin-bottom: 1rem;
    padding: 0.5rem;
    background-color: #fee2e2;
    border-radius: 0.375rem;
  }
  
  .error-summary {
    background-color: #fee2e2;
    border: 1px solid #ef4444;
    border-radius: 0.375rem;
    padding: 1rem;
    margin-bottom: 1.5rem;
  }
  
  .error-summary h2 {
    color: #b91c1c;
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  
  .error-summary ul {
    margin: 0;
    padding-left: 1.25rem;
    color: #b91c1c;
  }
  
  .form-group {
    margin-bottom: 1.25rem;
  }
  
  .form-label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.375rem;
  }
  
  .form-input {
    width: 100%;
    padding: 0.625rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 1rem;
  }
  
  .form-input.error {
    border-color: #ef4444;
    background-color: #fef2f2;
  }
  
  .form-hint {
    font-size: 0.875rem;
    color: #6b7280;
    margin-top: 0.25rem;
  }
  
  .error-message {
    color: #ef4444;
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }
  
  .form-actions {
    margin-top: 1.5rem;
  }
  
  .save-button {
    background-color: #047857;
    color: white;
    border: none;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
  }
  
  .save-button:hover {
    background-color: #065f46;
  }
  
  .back-link {
    margin-top: 1.5rem;
  }
  
  .back-link a {
    color: #047857;
    text-decoration: none;
  }
  
  .back-link a:hover {
    text-decoration: underline;
  }
</style>